module.exports = __webpack_public_path__ + "img/60_13.80da6fc2.png";